import React, { useState } from 'react';
import { API_BASE } from '../config';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    const resp = await fetch(`${API_BASE}/auth/forgot-password`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email }),
    });
    const data = await resp.json();
    if (resp.ok) setSent(true);
    else setError(data.error || 'Something went wrong.');
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg)' }}>
      <div style={{ background: 'var(--panel)', padding: '32px', borderRadius: '12px', border: '1px solid var(--panel-border)', maxWidth: '360px', width: '100%' }}>
        <h2 style={{ color: 'var(--accent)', fontSize: '1.1rem', marginBottom: '16px' }}>🔐 Reset Password</h2>
        {sent ? (
          <p style={{ color: 'var(--text)', fontSize: '0.8rem' }}>If that email exists, a reset link has been sent. Check your inbox.</p>
        ) : (
          <form onSubmit={handleSubmit}>
            <input type="email" placeholder="Your email" value={email} onChange={e => setEmail(e.target.value)} required style={{ width: '100%', padding: '10px', marginBottom: '12px', background: 'var(--bg)', border: '1px solid var(--panel-border)', borderRadius: '6px', color: 'var(--text)', fontSize: '0.8rem', boxSizing: 'border-box' }} />
            {error && <p style={{ color: '#ff4444', fontSize: '0.7rem', marginBottom: '8px' }}>{error}</p>}
            <button type="submit" style={{ width: '100%', padding: '10px', background: 'var(--accent)', color: '#000', border: 'none', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer' }}>Send Reset Link</button>
          </form>
        )}
        <a href="/login" style={{ display: 'block', marginTop: '16px', textAlign: 'center', color: 'var(--text-dim)', fontSize: '0.7rem' }}>← Back to login</a>
      </div>
    </div>
  );
}
